import store, { defaultMailSearchStore } from '../store/store';
import { mutator } from 'satcheljs';
import resetStoreOnSessionEnd from '../actions/resetStoreOnSessionEnd';

mutator(resetStoreOnSessionEnd, () => {
    store.isAdvancedSearchVisible = false;
    store.fromDate = defaultMailSearchStore.fromDate;
    store.includeAttachments = defaultMailSearchStore.includeAttachments;
    store.toDate = defaultMailSearchStore.toDate;
    store.isSearchHistoryDirty = defaultMailSearchStore.isSearchHistoryDirty;
    store.previousNode = defaultMailSearchStore.previousNode;
});
